//@ts-nocheck
import React from 'react'
import {Category, initValues} from '../../../../../_metronic/helpers'
import Swal from 'sweetalert2'

import {Field, Form, Formik} from 'formik'
import {categoryValidationSchema} from '../core/init'
import {createCategory} from '../../core/requests'
interface DialogProps {
  onDismiss: () => void
  onSave: () => void
  refetch: () => void
  onNewCategory: (category: any) => void
}

const CreateCategoryModal: React.FC<DialogProps> = ({
  onDismiss,
  refetch,
  onSave,
  onNewCategory,
}) => {
  const formValues: Category = {
    name: initValues.name || '',
  }
  const handleSave = async (values: Category) => {
    // console.log('values', values)
    // await createCategory(values)
    // onSave()
    // refetch()
    try {
      const isValid = await categoryValidationSchema.isValid(values)
      if (!isValid) {
        const validationErrors = await categoryValidationSchema
          .validate(values, {abortEarly: false})
          .catch((err) => err.inner)
        const formErrors = validationErrors.reduce((acc, curr) => {
          acc[curr.path] = curr.message
          return acc
        }, {})
        setErrors(formErrors)
        // setSubmitting(false)
        return
      }
      await createCategory(values)
      onNewCategory(values)
      onSave()
      refetch()
    } catch (error) {
      console.error('Form submission error', error)
      Swal.fire({
        icon: 'error',
        title: 'Erreur!',
        text: "l'intitulé est obligatoire",
      })
    } finally {
      console.log('Form submission')
      // setSubmitting(false)
    }
  }

  return (
    <>
      <div
        className='modal fade show d-block'
        id='modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <form noValidate className='ng-pristine ng-invalid ng-touched'>
              <div className='modal-header'>
                <div className='card-title mt-0 fw-bold fs-5'>Ajouter Catégorie</div>
              </div>
              <div className='modal-body'>
                <Formik
                  id='modal_add_user_form'
                  initialValues={formValues}
                  onSubmit={handleSave}
                  validationSchema={categoryValidationSchema}
                >
                  {({touched, errors, isValid, values}) => (
                    <Form>
                      {/* <div className='form-group row mb-2'>
                        <label className=' col-3 required fw-semibold fs-6 mb-2'>Label</label>
                        <div className='col-9'>
                          <Field
                            name='label'
                            className='form-control d mb-3 mb-lg-0'
                            type='text'
                            // className='form-control'
                          />
                          {touched.label && errors.label && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.label}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div> */}
                      <div className='form-group row mb-2'>
                        <label className=' col-3 required fw-semibold fs-6 mb-2'>Intitulé</label>
                        <div className='col-9'>
                          <Field
                            name='name'
                            className='form-control d mb-3 mb-lg-0'
                            type='text'
                            // className='form-control'
                          />
                          {touched.name && errors.name && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.name}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className='modal-footer pe-0 mt-3'>
                        <button
                          type='button'
                          onClick={onDismiss}
                          className='btn btn-outline-secondary mr-5'
                        >
                          <i className='fas fa-arrow-left'></i> Annuler
                        </button>
                        <button
                          type='button'
                          onClick={() => handleSave(values)}
                          className='btn btn-primary ml-5 pl-5'
                        >
                          <i className='fas fa-save'></i> Enregistrer
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export default CreateCategoryModal
